<template>
  <div class="myCenter modelPage formStyle questionPage">
    <navbar :nav="nav"></navbar>
    <div class="questionContent">
      <div class="searchBox">
        <img class="icon" src="../../assets/img/icon/icon_search.png" />
        <!-- <input class="input" v-model="search"
        placeholder="キーワード検索" enterkeyhint="search"> -->
        <form action="javascript:return true;">
          <input
            @keyup.13="show()"
            type="search"
            ref="input1"
            class="input"
            v-model="search"
            placeholder="キーワード検索"
          />
        </form>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        :immediate-check="false"
        @load="onLoad"
      >
        <div class="loginForm cellListStyle mtop16" style="width: 100%;">
          <van-cell
            is-link
            v-for="(item, index) in data"
            :key="index"
            :title="item.title"
            @click="
              $router.push({ path: `/questionDetail`, query: { id: item.id } })
            "
            ><template #label>
              <div
                class="desc"
                style="height: 24px; overflow: hidden;"
                v-html="item.content"
              ></div>
            </template>
          </van-cell>
        </div>
      </van-list>
      <div v-if="noData" class="noData mtop16">該当する結果が見つかりませんでした~</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { List } from "vant";

Vue.use(List);
// 课程指南、常见问题
import { helpList } from "@/http/user";
import navbar from "../../components/navbar/index.vue";
export default {
  components: {
    navbar
  },

  data() {
    return {
      nav: {
        back: true,
        title: "チュートリアル",
        chat: false
      },
      search: "",
      data: [],
      noData: false,
      loading: false,
      finished: false,
      pageNo: 1,
      total: 0
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    show() {
      this.data = [];
      this.$refs.input1.blur();
      this.getData();
    },
    onLoad() {
      this.pageNo++;
      this.getData();
    },
    getData() {
      let query = {
        title: this.search,
        pageNo: this.pageNo,
        pageSize: 10
      };
      helpList(query).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          let list = data.list;
          this.total = data.total;
          if (list == null || list.length === 0) {
            //加载结束
            this.data = [];
            this.finished = true;
            this.noData = true;
            return;
          }
          this.data = this.data.concat(data.list);
          if (this.data.length >= this.total) {
            this.finished = true;
            this.noData = false;
          }
        }
        this.loading = false;
      });
    }
  }
};
</script>

<style src="@/assets/css/mycenter.css" scoped></style>
<style src="@/assets/css/form.css" scoped></style>
<style>
.questionPage.aiPageBg {
  height: calc(100% - 40px);
}
.questionContent {
  /* margin-top: 60px; */
  width: calc(100% - 30px);
  padding: 0 15px 25px 15px;
  height: calc(100% - 25px);
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
}
.myCenter.formStyle.questionContent .loginForm {
  width: 100% !important;
}
.questionPage .searchBox {
  height: 44px;
  border-radius: 48px;
  background: #f8f8f8;
  box-sizing: border-box;
  border: 0.49px solid rgba(255, 255, 255, 0.3);
  position: relative;
  margin: 0 0 16px 0;
}

.questionPage .searchBox .icon {
  width: 16px;
  height: 16px;
  position: absolute;
  left: 16px;
  top: 13px;
  z-index: 6;
}
.questionPage .searchBox .input {
  border: none;
  font-family: RegularFont;
  font-size: 14px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.9);
  height: 40px;
  line-height: 40px;
  margin-left: 38px;
  background-color: transparent;
  width: calc(100% - 38px);
}
.questionPage .searchBox input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.questionPage .searchBox .input::input-placeholder {
  color: rgb(35, 32, 54, 0.3);
}
.questionPage .searchBox .input::-webkit-input-placeholder {
  color: rgb(35, 32, 54, 0.3);
}
.questionPage .searchBox .input::-moz-placeholder {
  color: rgb(35, 32, 54, 0.3);
}
.questionPage .searchBox .input::-moz-placeholder {
  color: rgb(35, 32, 54, 0.3);
}
.questionPage .searchBox .input::-ms-input-placeholder {
  color: rgb(35, 32, 54, 0.3);
}
.myCenter.formStyle.questionPage .loginForm.cellListStyle .van-cell {
  height: 84px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
  line-height: 24px;
  font-family: MediumFont;
}
.myCenter.formStyle.questionPage
  .loginForm.cellListStyle
  .van-cell__right-icon {
  line-height: 24px;
}
.myCenter.formStyle.questionPage
  .loginForm.cellListStyle
  .van-cell
  .van-cell__title,
.myCenter.formStyle.questionPage
  .loginForm.cellListStyle
  .van-cell.van-cell__value {
  width: calc(100% - 28px);
  box-sizing: border-box;
}
.questionPage .van-cell__label,
.questionPage .desc p {
  font-family: RegularFont;
  font-size: 14px;
  margin-top: 9px;
  font-weight: normal;
  color: #232036;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 24px;
}
.questionPage .van-cell__label p {
  padding: 0;
  margin: 0;
  font-size: 14px;
}
.questionPage .noData {
  font-size: 14px;
  text-align: center;
}
@media screen and (min-width: 1439px) {
  .questionPage.aiPageBg {
    height: calc(100% - 40px); /* no*/
  }
  .questionContent {
    /* margin-top: 60px; */
    width: calc(100% - 30px); /* no*/
    padding: 0 15px 25px 15px; /* no*/
    height: calc(100% - 25px); /* no*/
  }
  .questionPage .searchBox {
    height: 44px; /* no*/
    border-radius: 48px; /* no*/
    border: 0.49px solid rgba(255, 255, 255, 0.3); /* no*/
    margin: 0 0 16px 0; /* no*/
  }

  .questionPage .searchBox .icon {
    width: 16px; /* no*/
    height: 16px; /* no*/
    left: 16px; /* no*/
    top: 13px; /* no*/
  }
  .questionPage .searchBox .input {
    font-size: 14px; /* no*/
    height: 40px; /* no*/
    line-height: 40px; /* no*/
    margin-left: 38px; /* no*/
    width: calc(100% - 38px); /* no*/
  }
  .myCenter.formStyle.questionPage .loginForm.cellListStyle .van-cell {
    height: 84px; /* no*/
    font-size: 16px; /* no*/
    line-height: 24px; /* no*/
  }
  .myCenter.formStyle.questionPage
    .loginForm.cellListStyle
    .van-cell__right-icon {
    line-height: 24px; /* no*/
  }
  .myCenter.formStyle.questionPage
    .loginForm.cellListStyle
    .van-cell
    .van-cell__title,
  .myCenter.formStyle.questionPage
    .loginForm.cellListStyle
    .van-cell.van-cell__value {
    width: calc(100% - 28px); /* no*/
  }
  .questionPage .van-cell__label {
    font-size: 14px; /* no*/
    margin-top: 4px; /* no*/
    height: 24px; /* no*/
  }
  .questionPage .noData,
  .questionPage .van-cell__label p {
    font-size: 14px; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/model/question.vue